import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { StateContext } from "../../context/StateContext";

const Companies = () => {
  const { searchValue } = useContext(StateContext);
  const [companies, setCompanies] = useState([]);
  useEffect(() => {
    fetch("companies.json")
      .then((res) => res.json())
      .then((data) => setCompanies(data));
  }, []);
  console.log(companies);
  return (
    <div className="bg-teal-300 flex justify-center md:py-28">
      <div className="md:w-fit w-full bg-white p-10">
        <h2 className="text-2xl font-bold">
          To find a broadband deal, select your address
        </h2>
        <p className="mt-3 mb-6">You'll see the deals available in your area</p>
        <hr />
        <p className="mb-3 mt-6">What’s your address at SE1 2LH?</p>
        <Link
          to="/"
          className="border-b border-black pb-1 w-fit cursor-pointer flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 mr-1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
            />
          </svg>
          Back
        </Link>
        {searchValue?.length > 0 ? (
          <div className="mt-3">
            <select className="w-full">
              {companies
                .filter((com) =>
                  com.company.toLowerCase().includes(searchValue.toLowerCase())
                )
                .map((company) => (
                  <option>
                    {company.company}, {company.postcode}
                  </option>
                ))}
            </select>
          </div>
        ) : (
          <p className="flex justify-center text-3xl md:text-5xl font-bold">
            Sorry, No Company Availaval...
          </p>
        )}
      </div>
    </div>
  );
};

export default Companies;
